import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal } from "./Reveal";

const FAQS = [
  {
    q: "What is Foodie Crave?",
    a: "Foodie Crave is a dining experience app with restaurant discovery built in. It helps you find places to eat, save restaurants, track your visits, and remember your favorite dining experiences.",
  },
  {
    q: "Do I need friends to use Foodie Crave?",
    a: "No. Foodie Crave is designed for individuals, couples, families, and groups. You can discover restaurants, save places, and track your experiences entirely on your own.",
  },
  {
    q: "Can I use Foodie Crave while traveling?",
    a: "Yes. You can explore restaurants in other locations and save interesting places to visit during your travels.",
  },
  {
    q: "Can I invite friends or family?",
    a: "Yes. Invitations are available when you want to coordinate a dining outing — share an invite link and they can view the plan and vote from their browser, no account required. Group planning is always optional.",
  },
  {
    q: "Does Foodie Crave use AI to choose restaurants for me?",
    a: "Foodie Crave focuses on making restaurant discovery straightforward through search, maps, preferences, and available discovery tools. You can explore without needing to have a conversation with an AI assistant.",
  },
  {
    q: "Is Foodie Crave free?",
    a: "Yes. Anyone can run unlimited Discover searches as a guest, and a free account adds 3 places, 3 friends, and 3 invitations. Premium — $2.99/month or $15.99 for your first year ($19.99/year after) — raises those limits to 50 each and starts with a 30-day free trial.",
  },
  {
    q: "Which devices does Foodie Crave support?",
    a: "Android testing is live on Google Play — tap Get Early Access to join. iOS is coming soon; join the waiting list and we'll email you when it's ready.",
  },
  {
    q: "Can our group vote on where to eat?",
    a: "Yes — when you're dining together, start a vote from your saved places and everyone picks their favorite. It's an optional part of invitations, never required.",
  },
  {
    q: "What happens when I reach my Invitation limit?",
    a: "You can delete invitations you no longer need to make room for new ones. Free accounts can keep up to 3 Invitations, while Premium accounts can keep up to 50. These limits may be adjusted as Foodie Crave grows.",
  },
  {
    q: "What happens to my saved places and friends if I cancel Premium?",
    a: "Your information stays associated with your account. When your Premium access ends, you can continue with Free membership and select up to 3 Places and 3 Friends to keep accessible. Your remaining items will be locked rather than deleted. You can unlock them again by reactivating Premium. This is the planned membership experience.",
    planned: true,
  },
];

export const Faq = () => (
  <section
    id="faq"
    data-testid="faq-section"
    className="scroll-mt-24 border-t border-crave-border bg-[#181514] py-24 md:py-32"
  >
    <div className="mx-auto max-w-3xl px-6 md:px-12">
      <Reveal className="text-center">
        <p className="text-xs font-bold uppercase tracking-[0.28em] text-crave-gold">FAQ</p>
        <h2 className="mt-4 font-display text-4xl font-medium leading-[1.05] tracking-tight text-crave-cream sm:text-5xl">
          Hungry for answers?
        </h2>
      </Reveal>

      <Reveal delay={0.1}>
        <Accordion type="single" collapsible className="mt-12 w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="border-crave-border"
              data-testid={`faq-item-${i}`}
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${i}`}
                className="text-left font-display text-xl font-medium text-crave-cream transition-colors hover:text-crave-gold hover:no-underline"
              >
                <span className="flex flex-wrap items-center gap-3">
                  {f.q}
                  {f.planned && (
                    <span className="rounded-full bg-crave-gold/15 px-2.5 py-0.5 font-sans text-[10px] font-bold uppercase tracking-wider text-crave-gold">
                      Planned
                    </span>
                  )}
                </span>
              </AccordionTrigger>
              <AccordionContent className="text-base leading-relaxed text-crave-muted">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
